/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';

const RestrictHiringSolutionsGate: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  const { restrictHiringSolutions } = useContext(ProfileContext);

  if (restrictHiringSolutions) {
    return null;
  }

  return <>{children}</>;
};

export default RestrictHiringSolutionsGate;
